import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RiStarFill } from 'react-icons/ri'
import { Button, LibraryComponentType, Text } from 'yolda-web-ui'
import { LanguageHelper } from '../../../utils/helpers'
import { StyledMakeReview, MakeReviewStart } from './MakeReview.style'

const redirections = {
  de: 'https://g.page/r/CesEoikVA-IgEAI/review',
  en: 'https://g.page/r/CesEoikVA-IgEAI/review',
  tr: 'https://g.page/r/Cc1Ps41EZD4iEAI/review',
}

interface MakeReviewProps extends LibraryComponentType {}

const MakeReview: FC<MakeReviewProps> = ({ onClose }) => {
  const lang = LanguageHelper.get()
  const { t } = useTranslation()

  const onClick = () => {
    window.open(redirections?.[lang as keyof typeof redirections], '_blank')
    onClose?.()
  }

  return (
    <StyledMakeReview>
      <MakeReviewStart>
        {new Array(5).fill('').map(start => (
          <RiStarFill size={32} />
        ))}
      </MakeReviewStart>
      <Text as="div" fontSize="large" mb={'1rem'}>
        {t('modal.makeReview.title')}
      </Text>
      <Text as="div" mb={'2rem'}>
        {t('modal.makeReview.desc')}
      </Text>
      <Button onClick={onClick} mb={'1rem'}>
        {t('modal.makeReview.button')}
      </Button>
    </StyledMakeReview>
  )
}

export default MakeReview
